<template>
  <pt-news-classify-form class="pt-news-classify-form__page" :id="id" :isEdit="is_edit"></pt-news-classify-form>
</template>

<script>
import PtNewsClassifyForm from 'cps/information-manage/pt-news-manage/pt-news-classify/pt-news-classify-form'
export default {
  name: 'pt-news-classify-form__view',
  components: {
    'pt-news-classify-form': PtNewsClassifyForm
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: [Boolean, String],
      default: false
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
